import ContainerFlex from "components/ContainerFlex";
import Input from "components/input";
import KeyboardWrapper from "components/Keyboard";
import useApi, { ApiMethod } from "hooks/useApi";
import { SecurityPageProps } from "models/security";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { addCriarSenhaUnlockCartao } from "redux/features/cartao/desbloqueio-slice";
import { resetLoading, setLoading } from "redux/ui/loadings-slice";
import Endpoints from "services/api/endpoints";
import { showMessage } from "utils/messages";

import * as St from "./styles";

const ClienteSenhaUsuarioAtivo: React.FC<SecurityPageProps> = ({
  nextStep,
  backStep,
}) => {
  const [input, setInput] = useState("");
  const [value, setValue] = useState("");

  const keyboard = useRef(null);
  const history = useHistory();
  const dispatch = useAppDispatch();

  const {
    cartao: { cpf },
  } = useAppSelector((state) => state.cartaoDesbloqueio);

  useEffect(() => {
    if (input.length <= 6) {
      setValue(input);
    }
  }, [input]);

  const postValidarSenhaUsuario = useApi<any>(
    Endpoints.usuario.postValidarSenhaUsuario,
    ApiMethod.POST,
  );

  // o totem nao tem recuperacao de senha; a saida aqui e mandar o cliente para o app
  const handleEsqueciSenha = () => {
    showMessage(
      "info",
      "Esqueceu a senha?",
      "Abra o app TeuCard no teu celular, toque em Esqueci minha senha e crie uma nova. Pelo app você também consegue desbloquear o cartão, sem precisar voltar aqui.",
      { confirmButtonText: "Entendi", confirmButtonColor: "#33A733" },
    );
  };

  const handleSubmit = async () => {
    if (value.length !== 6) {
      showMessage("warning", "Atenção!", "A senha deve conter 6 dígitos", {
        timer: 5000,
        showConfirmButton: false,
      });
      return;
    }

    dispatch(setLoading(true));
    try {
      const response = await postValidarSenhaUsuario.callApi({
        cpf,
        senha: value,
      });

      if (response.status === 204) {
        dispatch(addCriarSenhaUnlockCartao(value));
        history.push(nextStep);
        return;
      }

      if (response.status === 403 || response.status === 404) {
        showMessage("warning", "Atenção!", "Senha incorreta, tente novamente.", {
          timer: 5000,
          showConfirmButton: false,
        });
        return;
      }

      showMessage(
        "error",
        "Atenção!",
        "Não foi possível validar tua senha. Tente novamente mais tarde.",
        { timer: 5000, showConfirmButton: false },
      );
    } catch (err) {
      showMessage(
        "error",
        "Atenção!",
        "Não foi possível validar tua senha. Tente novamente mais tarde.",
        { timer: 5000, showConfirmButton: false },
      );
    } finally {
      dispatch(resetLoading());
    }
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Desbloqueio</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          <span>Para continuar, digite a tua senha Teucard.</span>
        </St.Description>
      </ContainerFlex>

      <ContainerFlex center>
        <ContainerFlex width={60}>
          <ContainerFlex marginBottom={10}>
            <Input
              name="password"
              id="password"
              type="password"
              label="Valor"
              style={{
                height: "15%",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
              value={value}
              maxLength={6}
              onChange={(e) => setValue(e)}
              edit
              disabled
            />
          </ContainerFlex>
          <KeyboardWrapper
            onPressBack={() => history.push(backStep)}
            keyboardRef={keyboard}
            onChange={setInput}
            typeKeyboard="numeric"
            onPressEnter={() => handleSubmit()}
          />
          <ContainerFlex center marginTop={16}>
            <St.EsqueciSenha type="button" onClick={handleEsqueciSenha}>
              Esqueceu sua senha?
            </St.EsqueciSenha>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ClienteSenhaUsuarioAtivo;
